import { useEffect, useState } from "react";
import "./auth.scss";
import LoginPage from "./login/Login";
import OTPComponent from "./otp/OTP";
import ForgotPassword from "./forgotPassword/ForgotPassword";
import ResetPassword from "./resetPassword/ResetPassword";
import VerifyPassword from "./verifyPasssword/VerifyPassword";
import UpdatePassword from "./updatePassword/UpdatePassword";

const componentMap = {
  1: LoginPage,
  2: OTPComponent,
  3: ForgotPassword,
  5: ResetPassword,
  6: VerifyPassword,
  7: UpdatePassword,
};

const Auth = () => {
  const [step, setSteps] = useState(1);
  const [data, setData] = useState({});
  const [userId, setUserId] = useState("");
  const Component = componentMap[step];
  
  console.log({ step, data });
  return (
    <>
      <div className="auth_section">
        <div className="container">
          <div className="auth_content">
            <div className="content_right">
              {Component && (
                <Component setSteps={setSteps} data={data} setData={setData} setUserId={setUserId} userId={userId} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Auth;
